import { Pipe, PipeTransform } from '@angular/core';
import { DataAccessType } from './access-types';
import { ClientRole, UserAccessService } from './user-access.service';

/**
 * A pipe the check if user is allowed to perform a certain action: "can do" on a specific object or in general.
 * The input of the pipe is a DataAccessType which is usually created by a helper function like `accessAsset()`.
 *
 * Examples:
 *
 * Check if user can update this asset (data).
 * ```
 * AccessAsset(data) | can: 'update'
 * ```
 *
 * Check if user has upload role on any asset.
 * ```
 * AnyAsset | can: 'upload'
 * ```
 */
@Pipe({
  name: 'can',
})
export class CanPipe implements PipeTransform {
  constructor(private readonly userAccessService: UserAccessService) {}

  transform(value: DataAccessType, ...role: ClientRole[]): boolean {
    // TODO: add some short time caching here to avoid service calls for the same object.
    return this.userAccessService.canPerform(value, role);
  }
}

/**
 * Standalone version of the `can` pipe.
 *
 * A pipe the check if user is allowed to perform a certain action: "can do" on a specific object or in general.
 * The input of the pipe is a DataAccessType which is usually created by a helper function like `accessAsset()`.
 *
 * Examples:
 *
 * Check if user can update this asset (data).
 * ```
 * AccessAsset(data) | can: 'update'
 * ```
 *
 * Check if user has upload role on any asset.
 * ```
 * AnyAsset | can: 'upload'
 * ```
 */
@Pipe({
  name: 'canPipeStandAlone',
  standalone: true,
})
export class CanPipeStandAlone implements PipeTransform {
  constructor(private readonly userAccessService: UserAccessService) {}

  transform(value: DataAccessType, ...role: ClientRole[]): boolean {
    return this.userAccessService.canPerform(value, role);
  }
}

@Pipe({
  name: 'canNot',
})
export class CanNotPipe implements PipeTransform {
  constructor(private readonly userAccessService: UserAccessService) {}

  transform(value: DataAccessType, ...role: ClientRole[]): boolean {
    // TODO: add some short time caching here to avoid service calls for the same object.
    return !this.userAccessService.canPerform(value, role);
  }
}
